import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import swal from 'sweetalert2';
import * as Actions from '../../Actions/GlobalActions';

const PageDeconnexion = ({ actions, location }) => {
    let expire = false;
    if (location && location.search) {
        const params = new URLSearchParams(location.search);
        expire = params.has('expire');
    }

    actions.resetStore();
    sessionStorage.clear();

    if (expire) {
        swal('Non autorisé', 'La session a expiré. Veuillez vous reconnecter.', 'error');
    } else {
        swal('Déconnecté', 'Vous avez été déconnecté avec succès.', 'success');
    }

    return <Redirect to="/Connexion" />;
};
PageDeconnexion.displayName = 'PageDeconnexion';

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(Actions, dispatch) };
}

export default connect(null, mapDispatchToProps)(PageDeconnexion);



// WEBPACK FOOTER //
// ./src/components/App/PageDeconnexion.js